<template>
  <div class="workModel">
   
        <el-card class="box-card">
  <div>
    <h2>{{title}} <span v-show="!(name==null||name=='')">{{"("+name+")" }}</span></h2>
    <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
  </div>
  <div class="text item">
    {{createDate}}
   <h4>完成工作</h4>
      <p>{{WORK_CONTENT}}</p>
    <h4>存在问题：</h4>  
    <p>{{problem}}</p>
    <h4>其他建议：</h4>  
    <p>{{proposal}}</p>            
  </div>
</el-card>
        
   
    <div>

    </div>
  </div>
</template>

<script>
export default {
name:'InsertWorkModel',
 props:['WORK_CONTENT','title','problem','proposal','createDate','name'],
 created(){
  this.setValues()
 },
data(){
    return{
       
    }
},
methods:{
    setValues(){
    
    }
}
}
</script>

<style>
.workModel{
    width: 100%;
    height: 100%;
}
.title{
    width: 100%;
    text-align: center;
}
h2{
    text-align: center;
}
 p{white-space:pre-wrap;width:150px;
 width: 100%;}/*只对中文起作用，强制换行*/
</style>


// WEBPACK FOOTER //
// src/components/work/student/InsertWorkModel.vue